import React, { Component } from "react";
import styles from "./Content.module.css";

export default class Content extends Component {
  render() {
    return (
      <div className={`${styles.content_wrapper} content-wrapper`}>
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <BoxHeader />
                <BoxBody />
                {/* <BoxFooter /> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const BoxHeader = props => {
  return (
    <div className="box-header with-border">
      <h3 className="box-title">This is your dashboard home</h3>
    </div>
  );
};

const BoxBody = props => {
  return (
    <div className="box-body">
      <div className="row">
        <div className="col-md-8">
          <p className="text-center">
            <strong>Select a route from the sidebar</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

const BoxFooter = props => {
  return (
    <div className="box-footer">
      <div className="row">
        <div className="col-sm-3 col-xs-6">
          <div className="description-block border-right">
            <span className="description-percentage text-green">
              <i className="fa fa-caret-up" /> 17%
            </span>
            <h5 className="description-header">$35,210.43</h5>
            <span className="description-text">TOTAL REVENUE</span>
          </div>
        </div>
      </div>
    </div>
  );
};
